
const timeOutCalendar=(setShowed)=>{
    setTimeout(function() {
        setShowed(false);
    }, 3000);
}

export  {timeOutCalendar}